<ng-template #template>
  <div *ngIf="model.visible" class="svc-menu-action">
    <div [class]="model.buttonClassName" [key2click]="{ processEsc: false, disableTabStop: model.disableTabStop }"
      [attr.title]="model.tooltip" (click)="model.action()">
      <div class="svc-menu-action__icon">
        <div class="svc-menu-action__icon-container">
          <svg [iconName]="model.iconName" [size]="'auto'" sv-ng-svg-icon></svg>
        </div>
      </div>
    </div>
  </div>
</ng-template>